import { gql } from '@apollo/client';
import { IUserData } from '@agco-onedigital/ecosystem-lib-frontend-utils';
import { TLaunchDarklySet } from '../../../../store/LaunchDarkly';
import { TQueryResponse } from '../../../types';
import { client } from '../../graphql';

export const getUserData = async (launchDarkly: TLaunchDarklySet) => {
  const { data, errors } = await client(launchDarkly).query<TQueryResponse<'me', IUserData>>({
    query: gql`
      query {
        me {
          id
          locale
          salutation
          firstName
          lastName
          email
          phone
          mobilePhone
          externalIds {
            salesforceId
          }
          address
          zipCode
          stateProvinceName
          city
          country
          profilePicture
          accounts {
            account {
              id
              accountId
              region
              validationStatus
              name
              officePhone
              businessTypes
              farmTypes
              entityType
              registrationNumber
              country
              city
              address
              stateProvinceName
              zipCode
              externalIds {
                salesforceId
              }
            }
            roles
            isAdmin
          }
          lastUsedAccount {
            id
            name
          }
          features
          subscriptions {
            brand
            channelType
            type
            status
          }
          marketingConsentLevel
        }
      }
    `,
  });
  if (errors && errors.length > 0) {
    // Pass through GraphQL errors to let caller decide next step
    throw errors[0];
  }
  return data.me;
};
